import { GET_QUOTES_LIST } from "../../constants/customer/quoteConstants";



export const quoteActionCreate = {
    getQuotesList : () => ({
        type: GET_QUOTES_LIST,
    })
}